{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "RichText",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "html"
  ],
  "properties": {
    "html": {
      "title": "Content",
      "type": "string",
      "maxLength": 30000,
      "x-ui": "richtext"
    }
  }
}
